export class W3JobBlock {
  private locationFilter: HTMLSelectElement;
  private typeFilter: HTMLSelectElement;
  private jobElements: NodeListOf<Element>;

  constructor() {
    this.locationFilter = document.getElementById(
      "location-filter",
    ) as HTMLSelectElement;
    this.typeFilter = document.getElementById(
      "type-filter",
    ) as HTMLSelectElement;
    this.jobElements = document.querySelectorAll(".single-job");

    if (
      !this.locationFilter ||
      !this.typeFilter ||
      this.jobElements.length === 0
    ) {
      return;
    }

    this.addEventListeners();
    this.filterJobs(); // Initial filtering
  }

  /**
   * Add event listeners to the select elements
   */
  private addEventListeners() {
    this.locationFilter.addEventListener("change", () => this.filterJobs());
    this.typeFilter.addEventListener("change", () => this.filterJobs());
  }

  /**
   * Filter jobs based on selected location and type
   */
  private filterJobs() {
    const selectedLocations = Array.from(
      this.locationFilter.selectedOptions,
    ).map((option) => option.value);
    const selectedTypes = Array.from(this.typeFilter.selectedOptions).map(
      (option) => option.value,
    );
    let jobCount = 0;
    this.jobElements.forEach((job) => {
      const jobLocations = (job.getAttribute("data-location") || "").split(" ");
      const jobType = job.getAttribute("data-type");

      const matchesLocation =
        selectedLocations.length === 0 ||
        selectedLocations.includes("all") ||
        jobLocations.includes(selectedLocations[0]);
      const matchesType =
        selectedTypes.length === 0 ||
        selectedTypes.includes("all") ||
        selectedTypes.includes(jobType!);

      if (matchesLocation && matchesType) {
        (job as HTMLElement).style.display = "flex";
        jobCount++;
      } else {
        (job as HTMLElement).style.display = "none";
      }
    });
    if (jobCount >= 0) {
      document.getElementById("job-count--js")!.textContent = `${jobCount}`;
    }
  }
}
